var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag tag-default",class:_vm.quantitySpanClass(_vm.value)},[_vm._v(" "+_vm._s(_vm.value.toFixed(2))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }